/**
 * Banner de sistema só aparece junto do pedaço de conversa a que pertence.
 *
 * O endpoint de mensagens entrega as MENSAGENS em blocos (o último bloco ao
 * abrir, os anteriores conforme a pessoa rola pra cima), mas entrega os
 * EVENTOS de sistema — transferência, reabertura, chatbot — todos de uma vez,
 * na primeira resposta, desde o começo da história do contato naquele canal.
 *
 * Misturando os dois por horário, o resultado é uma pilha de banners de meses
 * atrás ACIMA do bloco carregado: quem abre uma conversa antiga vê uma lista
 * de "transferido de X para Y" e nenhuma mensagem. Rolando pra cima o bloco
 * antigo chega, as mensagens se encaixam entre os banners e tudo fica certo —
 * mas aí já se rolou demais e é preciso voltar pra baixo pra ler.
 *
 * O conserto é segurar cada banner até a conversa daquele tempo estar na tela:
 * vale o que for do horário da mensagem mais antiga já carregada pra cá. A
 * cada bloco novo o piso desce e os banners daquele período entram JUNTO das
 * mensagens deles.
 *
 * Com tudo carregado (não há bloco anterior), não há piso — nenhum banner
 * fica escondido, nem um evento anterior à primeira mensagem.
 */

/**
 * Horário a partir do qual os banners podem aparecer: o da mensagem mais
 * antiga já carregada. Devolve null (= mostrar todos) quando não há mais bloco
 * pra carregar, ou quando ainda não há mensagem alguma pra ancorar o piso.
 */
export function pisoDosBanners(
  carimbosCarregados: readonly string[],
  temBlocoAnterior: boolean,
): string | null {
  if (!temBlocoAnterior) return null;
  let piso: string | null = null;
  for (const c of carimbosCarregados) {
    if (piso === null || c.localeCompare(piso) < 0) piso = c;
  }
  return piso;
}

/** Os eventos que caem no pedaço já carregado (do piso pra cá). */
export function dentroDoBlocoCarregado<T>(
  eventos: readonly T[],
  carimbo: (evento: T) => string,
  piso: string | null,
): T[] {
  if (piso === null) return [...eventos];
  return eventos.filter((e) => carimbo(e).localeCompare(piso) >= 0);
}
